import { RootActionTypes } from '../../../stores/types';
import ActionTypes from '../constants/action-types';
import standardAction from '../../../utilities/standard-action';

export default function clearRefundAmount(): RootActionTypes {
  return standardAction(ActionTypes.CLEAR_REFUND_AMOUNT);
}
